// extracted by mini-css-extract-plugin
export default {"status":"L27O__","status__icon":"SnJP2W","status__icon--active":"VYqC4X","status__icon--inactive":"xWrKGn"};